/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Router\LangueProvider.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Thursday October 5th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Saturday, 3rd February 2024 12:40:03
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { createContext, ReactElement, useContext, useEffect, useMemo } from "react";
import translator from "MultiLanguage/TranslationWrapper";
import { useLocalStorage } from "Hooks/useLocalStorage";

const setMyLanguage = (lang: string) => {
};

export const LangContext = createContext({ language: "fr", setLanguage: setMyLanguage, translator });

export const LangProvider = (props: {children: ReactElement<any, any>}) => {
  const [language, setLanguage] = useLocalStorage<string>("language", "fr");

  useEffect(() => {
    changeLanguage(language);
  }, [, language]);

  const changeLanguage = (newLang: string) => {
    // translator.setLanguage(newLang);
    setLanguage(newLang);
  };

  const value = useMemo( () => {
    translator.setLanguage(language);
    return {
      language,
      setLanguage: changeLanguage,
      translator
    };
  }, [language]);

  return (<LangContext.Provider value={value}>{props.children}</LangContext.Provider>);
};

export const useLang = () => {
  return useContext(LangContext);
};
